import { render, staticRenderFns } from "./ResultadosCliente.vue?vue&type=template&id=2ce24c36"
import script from "./ResultadosCliente.vue?vue&type=script&lang=js"
export * from "./ResultadosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports